module.exports = __webpack_public_path__ + "static/media/caret-right.2555cfe7.svg";